import { render, staticRenderFns } from "./TrackingComponent.vue?vue&type=template&id=39c27c6a&scoped=true&"
import script from "./TrackingComponent.vue?vue&type=script&lang=js&"
export * from "./TrackingComponent.vue?vue&type=script&lang=js&"
import style0 from "./TrackingComponent.vue?vue&type=style&index=0&id=39c27c6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c27c6a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiButton: require('/app/components/UI/UiButton.vue').default,UiAccordionItem: require('/app/components/UI/UiAccordionItem.vue').default,UiAccordion: require('/app/components/UI/UiAccordion.vue').default})
